import { useEffect, useRef } from "react";
import { tawlaInviteHomePath, tawlaRegistrationAgentRid, tawlaRegistrationPath, tawlaRoomGamePath, isTawlaRegisteredPlayer } from "./TawlaRoomInvite";

// Keep the room in the existing auth return URL, including phone/email mode changes.
export function useTawlaRoomInvite({ location, history, getPersist, setPersist, getGameUrl, hallOrigin }) {
  const handled = useRef("");
  const loaded = getPersist("dataLoaded");
  const userInfo = getPersist("user_info");
  useEffect(() => {
    if (!loaded) return;
    if (location.pathname !== "/home" && location.pathname !== "/") {
      handled.current = "";
      return;
    }
    const returnPath = tawlaInviteHomePath(location.search);
    if (!returnPath) {
      handled.current = "";
      return;
    }
    const registered = isTawlaRegisteredPlayer(userInfo);
    const key = `${registered ? "game" : "register"}:${returnPath}`;
    if (handled.current === key) return;
    handled.current = key;
    const incoming = new URLSearchParams(returnPath.split("?")[1]);
    setPersist("agent_rid", tawlaRegistrationAgentRid(returnPath, ""));
    setPersist("agent_from", incoming.get("f") || "");
    if (registered) {
      history.replace(tawlaRoomGamePath(location.search, getGameUrl(3), hallOrigin));
    } else {
      setPersist("isLogin", false);
      setPersist("login_back_url", returnPath);
      history.replace(tawlaRegistrationPath(returnPath));
    }
  }, [loaded, location.pathname, location.search, userInfo, getGameUrl, hallOrigin, history, setPersist]);
}
